export const isProdEnviremonet = process.env.NODE_ENV === "production";



// WEBPACK FOOTER //
// ./src/helpers/node.js